import { render, staticRenderFns } from "./ActionDocumentsPayableItem.vue?vue&type=template&id=41117056&scoped=true"
import script from "./ActionDocumentsPayableItem.vue?vue&type=script&lang=ts"
export * from "./ActionDocumentsPayableItem.vue?vue&type=script&lang=ts"
import style0 from "./ActionDocumentsPayableItem.vue?vue&type=style&index=0&id=41117056&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41117056",
  null
  
)

export default component.exports